export function title({ commit }, title) {
  commit('title', title)
}
export function navColor({ commit }, navColor) {
  commit('navColor', navColor)
}
export function navTextColor({ commit }, navTextColor) {
  commit('navTextColor', navTextColor)
}
export function showNav({ commit }, showNav) {
  commit('showNav', showNav)
}

export function backTo({ commit }, data) {
  commit('backTo', data)
}

export function dialogDealer({ commit }, data) {
  commit('dialogDealer', data)
}

export function typeVehicle({ commit }, data) {
  commit('typeVehicle', data)
}

export function dialogMainMenu({ commit }, data) {
  commit('dialogMainMenu', data)
}

export function drawerMenu({ commit }, data) {
  commit('drawerMenu', data)
}
